<div class="flex flex-col w-full min-h-screen {{backgroundColor}}">
  <app-menu-header class="shrink-0 sticky top-0 z-40"></app-menu-header>
  <div class="flex-1 w-full">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="shrink-0"></app-footer>
</div>
